// Practice Test Results graph: all colors in one place.
// Multi-series (e.g. GRE): palette by theme; single-series: grey.

export const PRACTICE_GRAPH_COLORS = {
  light: [
    "#3272BE",
    "#E07C24",
    "#71BF8F",
    "#9B59B6",
    "#E74C3C",
  ],
  dark: [
    "#5B9BD5",
    "#F4A261",
    "#8FD9A8",
    "#B794F6",
    "#EC7063",
  ],
} as const;

// Grey for single-series graph (line + dots). Not from palette
export const PRACTICE_GRAPH_COLORS_SINGLE_SESSION = {
  light: "#6B6B6B",
  dark: "#9e9e9e",
} as const;

// Tooltip border and point fill colors by theme.
export const PRACTICE_GRAPH_UI_COLORS = {
  light: { tooltipBorderColor: "#BCBCBD", pointBackgroundColor: "#fff" },
  dark: { tooltipBorderColor: "#fff", pointBackgroundColor: "#1a1a1a" },
} as const;


export type PracticeGraphTheme = keyof typeof PRACTICE_GRAPH_COLORS;

// Returns the color palette for the given theme
export function getPracticeGraphPalette(
  theme: PracticeGraphTheme
): readonly string[] {
  return PRACTICE_GRAPH_COLORS[theme];
}

// Returns color for single series — index 0 (multi-series palette)
export function getPracticeGraphSingleSeriesColor(
  theme: PracticeGraphTheme
): string {
  return PRACTICE_GRAPH_COLORS[theme][0];
}

// Returns grey for single-series graph (line + dots). Used this for single data series
export function getPracticeGraphSingleSeriesGrey(
  theme: PracticeGraphTheme
): string {
  return PRACTICE_GRAPH_COLORS_SINGLE_SESSION[theme];
}

// Returns tooltip border and point background colors for the practice graph
export function getPracticeGraphUiColors(theme: PracticeGraphTheme) {
  return PRACTICE_GRAPH_UI_COLORS[theme];
}

// Returns color for a multi-series line by index. Uses color1–color5 in order
export function getPracticeGraphSeriesColor(
  theme: PracticeGraphTheme,
  seriesIndex: number
): string {
  const palette = PRACTICE_GRAPH_COLORS[theme];
  return palette[seriesIndex % palette.length];
}
